(function () {
  function normalizeTag(value) {
    return (value || '').trim().toLowerCase();
  }

  function buildPageItems(current, total) {
    if (total <= 1) return [1];

    var delta = 1;
    var maxVisible = delta * 2 + 1;

    if (total <= maxVisible + 2) {
      var all = [];
      for (var i = 1; i <= total; i += 1) all.push(i);
      return all;
    }

    var items = [];
    var start = current - delta;
    var end = current + delta;

    // 靠近开头：从第 1 页连续显示
    if (current <= delta + 1) {
      start = 1;
      end = Math.min(total, maxVisible);
      for (var p = start; p <= end; p += 1) items.push(p);
      if (end < total - 1) {
        items.push('ellipsis');
        items.push(total);
      } else if (end < total) {
        items.push(total);
      }
      return items;
    }

    // 靠近结尾：连续显示到末页
    if (current >= total - delta) {
      start = Math.max(1, total - maxVisible + 1);
      if (start > 2) {
        items.push(1);
        items.push('ellipsis');
      } else if (start > 1) {
        items.push(1);
      }
      for (var q = start; q <= total; q += 1) items.push(q);
      return items;
    }

    // 中间：仅当前页前后各 1 个数字，再接省略号与末页
    for (var n = start; n <= end; n += 1) {
      items.push(n);
    }
    items.push('ellipsis');
    items.push(total);
    return items;
  }

  function initBlogFilter(root) {
    var perPage = parseInt(root.getAttribute('data-per-page'), 10) || 4;
    var grid = root.querySelector('[data-mt-blog-grid]');
    var emptyEl = root.querySelector('[data-mt-blog-empty]');
    var pagination = root.querySelector('[data-mt-blog-pagination]');
    var pagePrev = root.querySelector('[data-mt-page-prev]');
    var pageNext = root.querySelector('[data-mt-page-next]');
    var pageList = root.querySelector('[data-mt-page-list]');
    var filterButtons = root.querySelectorAll('[data-mt-filter-btn]');
    var cards = Array.from(root.querySelectorAll('[data-blog-card]'));

    if (!grid || !cards.length) return;

    var state = {
      filterTag: '',
      currentPage: 1,
      visibleCards: cards.slice()
    };

    function getTotalPages() {
      return Math.max(1, Math.ceil(state.visibleCards.length / perPage));
    }

    function cardMatches(card, filterTag) {
      if (!filterTag) return true;
      var tags = (card.getAttribute('data-tags') || '').split('|').filter(Boolean);
      return tags.indexOf(filterTag) !== -1;
    }

    function setActiveFilterButton(filterTag) {
      filterButtons.forEach(function (btn) {
        var btnTag = normalizeTag(btn.getAttribute('data-filter'));
        var isActive = btnTag === filterTag;
        btn.classList.toggle('is-active', isActive);
        btn.setAttribute('aria-current', isActive ? 'true' : 'false');
      });
    }

    function syncUrl(filterTag) {
      var url = new URL(window.location.href);
      if (filterTag) {
        url.searchParams.set('tag', filterTag);
      } else {
        url.searchParams.delete('tag');
      }
      if (state.currentPage > 1) {
        url.searchParams.set('page', String(state.currentPage));
      } else {
        url.searchParams.delete('page');
      }
      window.history.replaceState({}, '', url);
    }

    function goToPage(page, options) {
      options = options || {};
      var totalPages = getTotalPages();
      state.currentPage = Math.min(Math.max(1, page), totalPages);
      renderPage();
      if (options.updateUrl !== false) {
        syncUrl(state.filterTag);
      }
      if (options.scroll !== false) {
        grid.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    }

    function renderPaginationControls() {
      if (!pagination || !pageList) return;

      var totalPages = getTotalPages();

      if (state.currentPage > totalPages) {
        state.currentPage = totalPages;
      }

      var showPagination = totalPages > 1;
      pagination.hidden = !showPagination;

      if (!showPagination) {
        pageList.innerHTML = '';
        return;
      }

      if (pagePrev) {
        pagePrev.disabled = state.currentPage <= 1;
      }
      if (pageNext) {
        pageNext.disabled = state.currentPage >= totalPages;
      }

      var items = buildPageItems(state.currentPage, totalPages);
      pageList.innerHTML = '';

      items.forEach(function (item) {
        if (item === 'ellipsis') {
          var ellipsis = document.createElement('span');
          ellipsis.className = 'mt-blog-filter__page-ellipsis';
          ellipsis.textContent = '...';
          ellipsis.setAttribute('aria-hidden', 'true');
          pageList.appendChild(ellipsis);
          return;
        }

        var btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'mt-blog-filter__page-num';
        btn.textContent = String(item);
        btn.setAttribute('data-page', String(item));
        btn.setAttribute('aria-label', 'Page ' + item);

        if (item === state.currentPage) {
          btn.classList.add('is-active');
          btn.setAttribute('aria-current', 'page');
        }

        btn.addEventListener('click', function () {
          goToPage(item);
        });

        pageList.appendChild(btn);
      });

      var activeBtn = pageList.querySelector('.mt-blog-filter__page-num.is-active');
      if (activeBtn && typeof activeBtn.scrollIntoView === 'function') {
        activeBtn.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
      }
    }

    function renderPage() {
      var total = state.visibleCards.length;
      var start = (state.currentPage - 1) * perPage;
      var end = start + perPage;

      cards.forEach(function (card) {
        card.hidden = true;
      });

      if (total === 0) {
        if (emptyEl) emptyEl.hidden = false;
        if (pagination) pagination.hidden = true;
        return;
      }

      if (emptyEl) emptyEl.hidden = true;

      state.visibleCards.forEach(function (card, index) {
        card.hidden = index < start || index >= end;
      });

      renderPaginationControls();
    }

    function applyFilter(filterTag, options) {
      options = options || {};
      state.filterTag = filterTag;
      state.currentPage = options.page || 1;
      state.visibleCards = cards.filter(function (card) {
        return cardMatches(card, filterTag);
      });

      setActiveFilterButton(filterTag);
      renderPage();
      if (options.updateUrl !== false) {
        syncUrl(filterTag);
      }
    }

    filterButtons.forEach(function (btn) {
      btn.addEventListener('click', function () {
        applyFilter(normalizeTag(btn.getAttribute('data-filter')));
      });
    });

    if (pagePrev) {
      pagePrev.addEventListener('click', function () {
        if (state.currentPage > 1) {
          goToPage(state.currentPage - 1);
        }
      });
    }

    if (pageNext) {
      pageNext.addEventListener('click', function () {
        if (state.currentPage < getTotalPages()) {
          goToPage(state.currentPage + 1);
        }
      });
    }

    var urlParams = new URLSearchParams(window.location.search);
    var urlTag = normalizeTag(urlParams.get('tag'));
    var dataTag = normalizeTag(root.getAttribute('data-initial-tag'));
    var initialTag = urlTag || dataTag;
    var initialPage = parseInt(urlParams.get('page'), 10) || 1;
    var hasMatchingButton = false;

    filterButtons.forEach(function (btn) {
      if (normalizeTag(btn.getAttribute('data-filter')) === initialTag) {
        hasMatchingButton = true;
      }
    });

    if (initialTag && !hasMatchingButton) {
      initialTag = '';
    }

    applyFilter(initialTag, { page: initialPage, updateUrl: false });
  }

  function initMobileDrawer(root) {
    var toggle = root.querySelector('[data-mt-blog-filter-toggle]');
    var drawer = root.querySelector('[data-mt-blog-filter-drawer]');
    var closeTriggers = root.querySelectorAll('[data-mt-blog-filter-close]');
    var filterButtons = root.querySelectorAll('[data-mt-filter-btn]');
    var mobileQuery = window.matchMedia('(max-width: 989px)');

    if (!toggle || !drawer) return;

    function isMobile() {
      return mobileQuery.matches;
    }

    function openDrawer() {
      drawer.classList.add('is-open');
      document.body.classList.add('mt-blog-filter-drawer-open');
      toggle.setAttribute('aria-expanded', 'true');
    }

    function closeDrawer() {
      drawer.classList.remove('is-open');
      document.body.classList.remove('mt-blog-filter-drawer-open');
      toggle.setAttribute('aria-expanded', 'false');
    }

    toggle.addEventListener('click', function () {
      if (!isMobile()) return;
      openDrawer();
    });

    closeTriggers.forEach(function (btn) {
      btn.addEventListener('click', function () {
        closeDrawer();
      });
    });

    filterButtons.forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (isMobile()) {
          closeDrawer();
        }
      });
    });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && drawer.classList.contains('is-open')) {
        closeDrawer();
      }
    });

    mobileQuery.addEventListener('change', function () {
      if (!isMobile()) {
        closeDrawer();
      }
    });
  }

  document.querySelectorAll('[data-mt-blog-filter]').forEach(function (root) {
    initMobileDrawer(root);

    root.querySelectorAll('[data-share-url]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var url = btn.getAttribute('data-share-url');
        if (!url) return;
        if (navigator.share) {
          navigator.share({ url: url, title: document.title }).catch(function () {});
        } else if (navigator.clipboard) {
          navigator.clipboard.writeText(url).catch(function () {});
        }
      });
    });

    initBlogFilter(root);
  });
})();
